module.exports = __webpack_public_path__ + "assets/SquareInCircleByPtDetailed.5a389e113ed63e4e7d7e62642e343d22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/SquareInCircleByPtDetailed.png
// module id = 567
// module chunks = 0